import { SortDescriptor } from '@progress/kendo-data-query'
import { ClientDtoKey, ClientFilterKey } from 'api/Clients/Types/Client'

export const normalizeSortQuery = (sortDescriptors: SortDescriptor[]): SortDescriptor[] =>
  sortDescriptors
    .map((x) => {
      if (x.field === ClientDtoKey.name) {
        return { ...x, field: ClientFilterKey.name }
      }
      if (x.field === ClientDtoKey.type) {
        return { ...x, field: ClientFilterKey.type }
      }
      if (x.field === ClientDtoKey.status) {
        return { ...x, field: ClientFilterKey.status }
      }
      if (x.field === ClientDtoKey.country) {
        return { ...x, field: ClientFilterKey.country }
      }
      if (x.field === ClientDtoKey.emailAddress) {
        return { ...x, field: ClientFilterKey.emailAddress }
      }
      if (x.field === ClientDtoKey.username) {
        return { ...x, field: ClientFilterKey.username }
      }
      if (x.field === ClientDtoKey.phone) {
        return { ...x, field: ClientFilterKey.phone }
      }
      if (x.field === ClientDtoKey.assignee) {
        return { ...x, field: ClientFilterKey.assignee }
      }
      if (x.field === ClientDtoKey.createdDate) {
        return { ...x, field: ClientFilterKey.createdDate }
      }
      if (x.field === ClientDtoKey.updatedDate) {
        return { ...x, field: ClientFilterKey.updatedDate }
      }
      if (x.field === ClientDtoKey.tickmillCompany) {
        return { ...x, field: ClientFilterKey.tickmillCompany }
      }
      if (x.field === ClientDtoKey.tickmillCompanyShort) {
        return { ...x, field: ClientFilterKey.tickmillCompanyShort }
      }
      if (x.field === ClientDtoKey.birthday) {
        return { ...x, field: ClientFilterKey.birthday }
      }
      return x
    })
    .filter((x) => !!x)
